var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pagination__total"},[_vm._v(_vm._s(_vm.i18n.t('el.pagination.total', { total: _vm.$parent.total })))])}
var staticRenderFns = []

export { render, staticRenderFns }